import { ModelPrompt, ModelPromptController } from "webmodals/model-prompt";
import deleteTemplateUrl from "emun.prospect/prospect-delete-confirmation.htm";
import fieldsetTemplateUrl from "emun.prospect/prospect-fieldset.htm";
import resolve from "ioc/resolve";
import prospectConfig from "emun.prospect/prospect.config";
import customerConfig from "emun.customer/customer.config";
import labels from "emun.prospect/_labels";
import CustomerNotePrompt from "emun.customer/customer-note-prompt";
import $session from "servicestack/session";

class ProspectPrompt extends ModelPrompt {
  constructor() {
    super();
    let $ctrl = this;
    $ctrl.prospectConfig = prospectConfig;
    $ctrl.customerConfig = customerConfig;
    $ctrl.labels = labels;
    this.seed = {
      status: "Active",
      country: "US",
      salesReps: [$session.salesRepId || $session.userAuthName],
    };
    $ctrl.upload = function ($files) {
      if ($files && $files.length) {
        let req = {
          request: {
            realm: "Prospect",
            tags: {
              ProspectId: model.id,
            },
          },
          files: $files,
          urls: [],
        };

        $ctrl.bus.upload("CreateMedia.json", req).then(function (response) {
          model.media = response.data.media[0];
        });
      }
    };
  }
  getTitle(model, action) {
    return `${action} prospect...`;
  }
  getQueryUrl(model, action) {
    return `QueryProspects.json?Id=${model && model.id}`;
  }
  getCommandUrl(model, action) {
    return `${action}Prospect.json`;
  }
  getModalBodyTemplateUrl(model, action) {
    return action === "Delete" ? deleteTemplateUrl : fieldsetTemplateUrl;
  }
  getController(model, action) {
    return ProspectPromptController;
  }
  onLoaded(model) {}
  onClosed(model) {
    if (model.media) {
      model.media.tags = {
        ProspectId: model.id,
      };
      $ctrl.bus.send("UpdateMedia", model.media);
    }
    if (model.customerId != "" && model.status == "Converted") {
      resolve("$state").go("customer.edit", { customerId: model.customerId });
    }
    if (model.status == "Dead") {
      var options = {
        title: "Reason for prospect status change",
        model: {
          customer: model,
          prospectmode: true,
          note: {
            note: "",
            createdBy: $session.userName,
            createdOn: new Date(),
            retailerId: model.id,
          },
        },
      };
      CustomerNotePrompt.open(options).then(function (res) {});
    }
  }
  toggleHot() {
    model.hot ? (model.hot = false) : (model.hot = true);
  }
}

class ProspectPromptController extends ModelPromptController {
  constructor($uibModalInstance, options) {
    super(options);
    const $ctrl = this;
    $ctrl.modal = $uibModalInstance;
    $ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
    $ctrl.$close = $ctrl.close = $uibModalInstance.close;
    $ctrl.config = prospectConfig;
    $ctrl.labels = labels;
  }
}

export default ProspectPrompt;
